module.exports = __webpack_public_path__ + "img/监控.c6b6a3b5.png";